<template lang="pug">
  section
    s-page-title(
      :previous='true'
      :title='id ? "Редактирование Баннера" : "Добавление Баннера"'
    )
    v-card
      v-container(grid-list-xl fluid)
        v-layout(wrap)
          v-flex(xs12 sm12)
            div(class="picker")
              s-publish-date-status(
                :errors='errors'
                :model='item'
              )
          v-flex(xs12)
            v-text-field(
              :error='errors.has("name")'
              :error-messages='errors.first("name")'
              v-model='item.name'
              label='Заголовок баннера'
            )
          v-flex(xs12)
            v-textarea(
              :error='errors.has("annotation")'
              :error-messages='errors.first("annotation")'
              v-model='item.annotation'
              label='Краткое описание'
              counter
            )

          v-flex(xs6)
            v-text-field(
              :error='errors.has("link")'
              :error-messages='errors.first("link")'
              v-model='item.link'
              label='Ссылка для перехода по кнопке (используйте относительные для корп сайта)'
            )     
          v-flex(xs6)
            v-text-field(
              :error='errors.has("link_name")'
              :error-messages='errors.first("link_name")'
              v-model='item.link_name'
              label='Текст на кнопке (по умолчению "Подробнее")'
            )     
          v-flex(xs4)
            s-auto-image-upload(
              v-model='item.picture'
              :src='item.picture_url'
              :parseResponse='r => r.hash'
              label='Фон для банера'
            )                           
          v-flex(xs12)
            s-region-picker(
              v-model='regions'
              chips
              multiple
            )
      v-card-actions(class='large')
        v-spacer
        s-back-btn
        v-btn(
          @click='onSave'
          :loading='isLoading'
          color='primary'
          depressed
        ) Сохранить
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  props: ['id'],

  data: () => ({
    item: {},
    bErrors: {},
    sorting: {
      opened: false,
      itemValue: 'id',
      itemText: 'name',
      renderFn(item) {
        if (item.name) return item.part + ` ` +item.name
        return item.part + ` ` +`<img src="${item.picture_url}" width="120"/>`
      }
    }
  }),

  async created() {
    if (!this.id) return
    this.updateItem()
    this.fetchGroups()
  },

  methods: {
    async updateItem() {
      const response = await this.fetchSingle({ id: this.id })
      this.item = response.data
    },

    async onSave() {
      const data = this.item
      try {
        if (this.id) await this.update({ id: this.id, data })
        else await this.create({ data })
        this.$root.showSnack('Сохранено')
        if(!this.id)
          this.$router.push({ name: 'Seo.Banners' })
      } catch (e) {
        this.$showServerErrors(e)
      }
    },

    ...mapActions('seo/banners', ['fetchSingle', 'update', 'create'])
  },

  computed: {
    regions: {
      get: function() {
        if (!this.item.regions) return []
        return this.item.regions.split(',')
      },
      set: function(val) {
        this.item.regions = val.join(',')
      }
    },

    ...mapGetters('seo/banners', ['isLoading'])
  }
}
</script>

<style scoped>
.small textarea {
  font-size: 12px;
}
</style>
